export default "__VITE_ASSET__B9stc8Cl__"